import {api} from './api';
import {FrameData} from '../types';

export const frameService = {
  async getFrameData(displayId?: string): Promise<FrameData> {
    const url = displayId
      ? `/api/v1/frame/data?displayId=${displayId}`
      : '/api/v1/frame/data';
    return api.get<FrameData>(url);
  },
};
